import { Volume2, VolumeX, Sparkles } from 'lucide-react';

/**
 * SettingsPanel Component
 * Toggle for sound and animations
 */
export default function SettingsPanel({ settings, onToggleSound, onToggleAnimations }) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-lg">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Indstillinger</h3>

      <div className="space-y-3">
        {/* Sound Toggle */}
        <button
          onClick={onToggleSound}
          className="w-full flex items-center justify-between p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
          aria-label={settings.soundEnabled ? 'Slå lyd fra' : 'Slå lyd til'}
        >
          <div className="flex items-center space-x-3">
            {settings.soundEnabled ? (
              <Volume2 className="text-green-600" size={24} />
            ) : (
              <VolumeX className="text-gray-400" size={24} />
            )}
            <span className="font-medium text-gray-700">Lydeffekter</span>
          </div>
          <div
            className={`w-12 h-6 rounded-full transition-colors ${
              settings.soundEnabled ? 'bg-green-500' : 'bg-gray-300'
            }`}
          >
            <div
              className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                settings.soundEnabled ? 'translate-x-6' : 'translate-x-1'
              } mt-0.5`}
            ></div>
          </div>
        </button>

        {/* Animations Toggle */}
        <button
          onClick={onToggleAnimations}
          className="w-full flex items-center justify-between p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
          aria-label={settings.animationsEnabled ? 'Slå animationer fra' : 'Slå animationer til'}
        >
          <div className="flex items-center space-x-3">
            <Sparkles
              className={settings.animationsEnabled ? 'text-purple-600' : 'text-gray-400'}
              size={24}
            />
            <span className="font-medium text-gray-700">Animationer</span>
          </div>
          <div
            className={`w-12 h-6 rounded-full transition-colors ${
              settings.animationsEnabled ? 'bg-purple-500' : 'bg-gray-300'
            }`}
          >
            <div
              className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                settings.animationsEnabled ? 'translate-x-6' : 'translate-x-1'
              } mt-0.5`}
            ></div>
          </div>
        </button>
      </div>
    </div>
  );
}
